module.exports = __webpack_public_path__ + "img/icon-close.919ab92a.svg";